// Small non-blocking notifications for the Teams page. Success/info fade after 3.5 s; errors
// and warnings stay until closed (they usually carry a reason the admin needs to read).
import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function useToasts() {
  const [toasts, setToasts] = useState([]);
  const seq = useRef(0);
  const dismiss = useCallback((id) => setToasts(list => list.filter(x => x.id !== id)), []);
  const push = useCallback((message, type = 'success') => {
    const id = ++seq.current;
    setToasts(list => [...list.slice(-3), { id, message, type }]);
    if (type === 'success' || type === 'info') setTimeout(() => dismiss(id), 3500);
  }, [dismiss]);
  return { toasts, push, dismiss };
}

export function Toasts({ toasts, dismiss }) {
  const { t } = useTranslation();
  if (!toasts.length) return null;
  return (
    <div className="tm-toasts" role="status" aria-live="polite">
      {toasts.map(x => (
        <div key={x.id} className={`tm-toast ${x.type}`}>
          <span className="msg">{x.message}</span>
          <button type="button" aria-label={t('common.close', 'Close')} onClick={() => dismiss(x.id)}>×</button>
        </div>
      ))}
    </div>
  );
}
